import { requestFixture } from "common/actions/fixtures";
import { fixturesSelector } from "common/selectors";
import { createConnector } from "common/connectors/utils";

export default createConnector("WithFixture", fixturesSelector, {
  onLoad: requestFixture,
});
